@if (!isMobile$) {

  <button sd-button-icon
    [class]="choiceOptions.length && selectedChoiceOptionsIdx === 0 || currentValue === minValue ? 'is-disabled' : ''"
    type="button"
    name="decrement"
    icon="icon-minus"
    [size]="iconSize.xs"
    (click)="onDecrement()"
    [buttonIconTitle]="('forms.increment.minus' | translate: {labelTitle: labelTitle})"
    [titleHidden]="true"
    [attr.aria-disabled]="minValue ? (currentValue === minValue) : false"
  ></button>

  <p aria-live="polite" aria-atomic="true" class="is-bold">
    {{currentValue}} {{labelTitle}}
  </p>

  <button sd-button-icon
    [class]="choiceOptions.length && selectedChoiceOptionsIdx === choiceOptions.length - 1 || currentValue === maxValue ? 'is-disabled' : ''"
    type="button"
    name="increment"
    icon="icon-plus"
    [size]="iconSize.xs"
    (click)="onIncrement()"
    [buttonIconTitle]="('forms.increment.plus' | translate: {labelTitle: labelTitle})"
    [titleHidden]="true"
    [attr.aria-disabled]="maxValue ? (currentValue === maxValue) : false"
  ></button>

} @else {

  <button sd-button
    type="button"
    class="c__btn-edit"
    [isSecondary]="true"
    [isSmall]="true"
    icon="icon-edit"
    [isIcon]="true"
  >
    <p aria-live="polite" aria-atomic="true">{{currentValue}} {{labelTitle}}</p>
  </button>

  <select name="valueInput" #select (change)="onUpdateValue(select)">
    @for (item of itemQty; track item) {
      <option [value]="item" tabindex="1">{{item}}</option>
    }
  </select>

}
